import { TestBed } from "@angular/core/testing";
import { Company } from "./company";
import { Contract } from "./contract";
import { User } from "./user";

export class Tester extends User {

    company?: Company;
    contracts?: Contract[];
    testbeds?: TestBed[];
    
}